<template>
  <modal :value="value"
         max-width="500"
         :has-padding="false"
         @input="hideModal">
    <div :key="form.id">
      <div class="form-body">
        <h1 class="text-muted text-center">
          {{$t('message.spots.message.spotsGroup')}}
        </h1>
        <v-text-field ref="firstInput"
                      :label="$t('message.generics.message.name')"
                      name="Nome"
                      v-validate="'required'"
                      :error-messages="errors.collect($t('message.generics.message.name'))"
                      v-model="form.name"></v-text-field>
      </div>

      <div class="card-footer">
        <button class="btn btn-primary btn-round"
                @click="validate()">
          {{ isEdit ? this.$t('message.generics.message.edit') : this.$t('message.spots.message.create')}}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    Modal,
  },

  data() {
    return {
      show: false,
      form: {},
      isEdit: false,
    };
  },

  mounted() {
    this.reset()
    EventBus.$on("ADD_GROUP_LOCAL", this.addGroupLocalHandler);
  },

  beforeDestroy() {
    EventBus.$off("ADD_GROUP_LOCAL", this.addGroupLocalHandler);
  },

  props: {
    initialData: {
      type: Object,
    },
    node: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },  

  computed: {},

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.emitInput(false);
    },
    setFocus() {
      if (this.show) {
        this.$nextTick(() => {
          this.$refs.firstInput.focus();
        });
      }
    },
    addGroupLocalHandler(item) {
      this.form = { parentId: item.id };
      this.isEdit = false;
      this.show = true;
    },
    reset() {
      this.form = {
        name: "",
      };
    },
    async validate() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.save();
      }
    },
    async save() {
      EventBus.$emit("SHOW_SPINNER");

      try {
        if (!this.isEdit) {
          const data = {
            nome: this.form.name,
            parentId:
              this.node && this.node.tipo === "GRUPO_LOCAL" && this.node.id,
          };

          const newGroup = await this.$api.localeGroup.create(data);

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t(
              "message.successMessages.message.spotsGroupCreated"
            ),
            timeout: 2000,
          });

          this.$emit("created", { ...newGroup, tipo: "GRUPO_LOCAL" });
        } else {
          const updatedLocaleGroup = await this.$api.localeGroup.update({
            id: this.form.id,
            nome: this.form.name,
            parentId: this.form.parentId,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t(
              "message.successMessages.message.spotsGroupEdited"
            ),
            timeout: 2000,
          });

          EventBus.$emit("UPDATE_NODE", {
            ...updatedLocaleGroup,
            tipo: "GRUPO_LOCAL",
          });

          EventBus.$emit("UPDATE_NODE", {
            ...updatedLocaleGroup,
            tipo: "GRUPO_LOCAL",
          });

          this.isEdit = false;
        }

        this.hideModal();
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },

    async edit(id) {
      const localeGroup = await this.$api.localeGroup.get({
        id,
      });

      this.form = {
        id: localeGroup.id,
        name: localeGroup.nome,
        parentId: localeGroup.parentId,
      };

      this.isEdit = true;      
    },
  },
  destroyed() {
    EventBus.$off("EDIT_GROUP_LOCAL_DATA");
    EventBus.$off("ADD_GROUP_LOCAL");
  },
};
</script>

<style lang="scss" scoped>
.form-body {
  padding: 18px 50px 10px;
}

.btn {
  margin-right: 10px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
}
</style>
